import { Component, OnInit, OnDestroy, input, inject } from "@angular/core";
import { ClozeTestStyleModel } from "../model/cloze-test-style-model";
import { Subscription } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { NgClass, NgStyle } from "@angular/common";

@Component({
  selector: "onset-cloze-test-ger-info",
  templateUrl: "./ger-info.component.html",
  styleUrls: ["./ger-info.component.scss"],
  standalone: true,
  imports: [NgClass, NgStyle, TranslatePipe],
})
export class GerInfoComponent implements OnInit, OnDestroy {
  readonly #route = inject(ActivatedRoute);
  readonly #ngxTranslate = inject(TranslateService);

  readonly clozeTestStyleModel = input({} as ClozeTestStyleModel);
  readonly cTestLogo = input("");
  readonly cTestButtonColor = input("");
  readonly mobileMode = input(false);

  readonly #subscription = new Subscription();

  ngOnDestroy(): void {
    this.#subscription.unsubscribe();
  }

  ngOnInit() {
    const langSub = this.#route.queryParams.subscribe((params) => {
      if (params["lang"]) {
        const lang = params["lang"] as string;
        this.#ngxTranslate.use(lang.toLowerCase());
      }
    });
    this.#subscription.add(langSub);
  }
}
